<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Profile",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Profile",
            items: [
               {
                  text: "Profile",
                  href: "/profile",
               },
               {
                  text: "Edit",
                  active: true,
               },        
            ],

            station: {
               name: 'Freshalicious Super Bazar',
               mobile: '9111111111',
               email: 'store@xyz.com',
               country_code: '91',

                       },

            station_location: 'Dubai - United Arab Emirates',
            station_marker: { position: { lat: 25.2048493, lng: 55.2707828 } },
            station_center: { lat: 25.2048493, lng: 55.2707828 },
            station_current_place: null,

            station_mapOptions: {
               disableDefaultUI: true,
            },

         };
      },
      mounted() {
    
      },

      methods: {
         //sets the position of marker when dragged
         stationHandleMarkerDrag(e) {
            this.station_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         stationPanToMarker() {
            this.$refs.stationMapRef.panTo(this.station_marker.position);
            this.$refs.stationMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         stationHandleMapClick(e) {
            this.station_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         stationSetPlace(place) {
            this.station_current_place = place;
            if(this.station_current_place) {
               const marker = {
                  lat: this.station_current_place.geometry.location.lat(),
                  lng: this.station_current_place.geometry.location.lng(),
               };
               this.station_center = marker;
               this.station_marker.position = marker;
               this.station_location = place.formatted_address;
            }
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'profile' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <form class="form-horizontal" role="form">
                     <b-card header-class="bg-transparent border-light" class="border border-light">
                     
                        <div class="row"> 

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.name"></b-form-input>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Mobile <span class="text-danger">*</span></label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="station.country_code">
                                       <option value="91">+91</option>
                                       <option value="971">+971</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="station.mobile"></b-form-input>
                              </b-input-group>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Email</label>
                              <b-form-input type="email" v-model="station.email"></b-form-input>
                           </b-form-group>                          

                           <!-- <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="stationSetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="station_location"/>
                              
                              <GmapMap v-if="station_location"
                                 :center="station_center"
                                 :zoom="18"
                                 map-style-id="station-roadmap"
                                 :options="station_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="stationMapRef"
                                 @click="stationHandleMapClick">
                                    <GmapMarker
                                       :position="station_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="stationHandleMarkerDrag"
                                       @click="stationPanToMarker"
                                    />
                              </GmapMap>                          
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="station_marker.position.lat"></b-form-input>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="station_marker.position.lng"></b-form-input>
                           </b-col>
 -->
                           <b-form-group class="col-lg-6 mb-3">
                              <label>Profile Image </label><br>
                              <img src="@/assets/images/users/fish.jpg" class="avatar-sm mb-2" alt="">
                              <input type="file" class="form-control" name="">
                              <p class="small">Leave this field empty if you do not want to edit the image</p>
                           </b-form-group>
                        <div class="12">
                           <button class="btn btn-primary me-2" type="submit">Save</button>
                           <router-link :to="{ name: 'profile' }" class="btn btn-light">Cancel</router-link>
                     </div>
                        </div>

                     </b-card>
                  
                    
                     </form>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
